export class BankAccountStatus {
  static ACTIVE = 1;
  static INACTIVE = 2;
  static UNCONSENTED = 3;
}
